import React from 'react'
import PropTypes from 'prop-types'

import usePaginator from '../../hooks/usePaginator'
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  DoubleArrowLeftIcon,
  DoubleArrowRightIcon,
  StyledIconButton,
  StyledPaginator,
  StyledPaginatorButton,
  StyledPaginatorDots,
  StyledPaginatorList,
} from './SearchPaginator.styled'

const DOTS = '...'
const PREV = 'prev'
const NEXT = 'next'
const CANONICAL = 'canonical'
export const LEFT = 'left'
const PAGINATOR = 'paginator'
const RIGHT = 'right'

const SearchPaginator = (props) => {
  const { className, count, currentPage, setCurrentPage } = props

  const [arrOfCurrPages] = usePaginator(count, currentPage)
  const buttonsList = arrOfCurrPages.map((pageNumber, index) => {
    if (pageNumber === DOTS) {
      return (
        <li key={PAGINATOR + index}>
          <StyledPaginatorDots>{DOTS}</StyledPaginatorDots>
        </li>
      )
    }
    const label = pageNumber.toString()
    return (
      <li key={PAGINATOR + index}>
        <StyledPaginatorButton
          $active={currentPage === pageNumber}
          label={label}
          onClick={() => setCurrentPage(pageNumber)}
        />
      </li>
    )
  })

  const createArrowsButtons = (
    simpleArrowPage,
    doubleArrowPage,
    orientation
  ) => {
    return (
      <>
        {orientation === RIGHT && (
          <li>
            <StyledIconButton
              ariaLabel="prev"
              onClick={() => setCurrentPage(simpleArrowPage)}
              rel={PREV}
            >
              <ArrowRightIcon />
            </StyledIconButton>
          </li>
        )}
        {count > 2 && (
          <li>
            <StyledIconButton
              onClick={() => setCurrentPage(doubleArrowPage)}
              rel={CANONICAL}
            >
              {orientation === LEFT ? (
                <DoubleArrowLeftIcon />
              ) : (
                <DoubleArrowRightIcon />
              )}
            </StyledIconButton>
          </li>
        )}
        <li>
          {orientation === LEFT && (
            <StyledIconButton
              ariaLabel="next"
              onClick={() => setCurrentPage(simpleArrowPage)}
              rel={NEXT}
            >
              <ArrowLeftIcon />
            </StyledIconButton>
          )}
        </li>
      </>
    )
  }

  const arrowsLeft = createArrowsButtons(currentPage - 1, 1, LEFT)

  const arrowsRight = createArrowsButtons(currentPage + 1, count, RIGHT)

  return (
    <StyledPaginator>
      <StyledPaginatorList className={className}>
        {!(currentPage <= 1) && count > 2 && (
          <li>
            <StyledIconButton
              ariaLabel="first"
              onClick={() => setCurrentPage(1)}
              rel={CANONICAL}
            >
              <DoubleArrowLeftIcon />
            </StyledIconButton>
          </li>
        )}
        {!(currentPage <= 1) && (
          <li>
            <StyledIconButton
              ariaLabel="prev"
              onClick={() => setCurrentPage(currentPage - 1)}
              rel={PREV}
            >
              <ArrowLeftIcon />
            </StyledIconButton>
          </li>
        )}
        {buttonsList}
        {!(currentPage === count) && (
          <li>
            <StyledIconButton
              ariaLabel="next"
              onClick={() => setCurrentPage(currentPage + 1)}
              rel={NEXT}
            >
              <ArrowRightIcon />
            </StyledIconButton>
          </li>
        )}
        {!(currentPage === count) && count > 2 && (
          <li>
            <StyledIconButton
              ariaLabel="last"
              onClick={() => setCurrentPage(count)}
              rel={CANONICAL}
            >
              <DoubleArrowRightIcon />
            </StyledIconButton>
          </li>
        )}
      </StyledPaginatorList>
    </StyledPaginator>
  )
}

SearchPaginator.propTypes = {
  className: PropTypes.string,
  count: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
}

export default SearchPaginator
